
import { Component, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import PronosticoMeteorologicoControl from '@/components/PronosticoMeteorologicoControl.vue'
import PronosticoLocalControl from '@/components/PronosticoLocalMapasControl.vue'
import EstacionesControl from '@/components/EstacionesControl.vue'
import PerfilControl from '@/components/PerfilControl.vue'
import PronosticoHidricoControl from '@/components/PronosticoHidricoControl.vue'
import PuntosPeligroControl from '@/components/PuntosPeligroControl.vue'
import ImagenesSatelitalesControl from '@/components/ImagenesSatelitalesControl.vue'
import MapaPeligroControl from '@/components/MapaPeligroControl.vue'
import { getEnvironments } from '@/environments'

const { settings: { PRONOSTICO_HIDRICO, PRONOSTICO_AIRE, PELIGRO, PUNTOS_PELIGRO, PRONOSTICO_METEOROLOGICO, ESTACIONES, PRONOSTICO_LOCAL } } = getEnvironments()
const ACCOUNT_MODULE = 'account'

  @Component({
    components: {
      ImagenesSatelitalesControl,
      PronosticoMeteorologicoControl,
      PronosticoLocalControl,
      EstacionesControl,
      PerfilControl,
      PronosticoHidricoControl,
      PuntosPeligroControl,
      MapaPeligroControl
    }
  })
export default class MapCustomControl extends Vue {
    @Getter('token', { namespace: ACCOUNT_MODULE })
    private token!: any
    descriptionShown: boolean = false;
    chevronLeft: string = 'img/icons/icon-chevron-circle-left.svg'
    chevronRight: string = 'img/icons/icon-chevron-circle-right.svg'

    private pronosticoHidricoConfs = PRONOSTICO_HIDRICO
    private pronosticoAireConfs = PRONOSTICO_AIRE
    private puntosPeligroConfs = PUNTOS_PELIGRO
    private peligroConfs = PELIGRO
    private monitoreoConfs = ESTACIONES
    private pronosticoMeteorologicoConfs = PRONOSTICO_METEOROLOGICO
    private pronosticoLocalConfs = PRONOSTICO_LOCAL

    openMenu: string[] = [
      'pronostico-hidrico',
      'pronostico-aire',
      'pronostico-meteorologico',
      'pronostico-local',
      'imagenes-satelitales',
      'estaciones',
      'peligro'
    ]

    changeDescriptionValue (value: boolean) {
      this.descriptionShown = value
      return value
    }

    toggleDescriptions (isDescriptionShown: boolean): boolean {
      this.descriptionShown = !isDescriptionShown
      return this.isDescriptionShown
    }

    changeDescriptionShown (type: string) {
      this.changeDescriptionValue(this.shouldDescriptionShown(type))
    }

    shouldDescriptionShown (type: string) {
      if (this.openMenu.find(e => e === type)) {
        return true
      }
      return false
    }

    getArrowCircle (isDescriptionShown: boolean): string {
      return isDescriptionShown ? this.chevronRight : this.chevronLeft
    }

    get isDescriptionShown () {
      return this.descriptionShown
    }

    created () {
      const path = this.$route.path.substring(1)
      this.changeDescriptionShown(path)
      Vue.preGroup({
        document: [this.chevronLeft, this.chevronRight]
      }, 'prefetch')
    }
}
